// extracted by mini-css-extract-plugin
export default {"list":"CollapsableList-module__list__2oBuu","button":"CollapsableList-module__button__aVO9o"};